import axios from 'axios'
import store from '../store'

// 设置通用拦截器
const setInterceptors = (instance) => {
  instance.interceptors.request.use(config => {
    store.dispatch('setLoading', true)
    if (localStorage.jwtToken) {
      config.headers.Authorization = localStorage.jwtToken
    }
    return config
  }, error => {
    store.dispatch('setLoading', false)
    return Promise.reject(error)
  })

  instance.interceptors.response.use(response => {
    store.dispatch('setLoading', false)
    return response
  }, error => {
    store.dispatch('setLoading', false)
    console.error('请求错误：', error.response.data.message || error.message)
    return Promise.reject(error)
  })
}

// 创建 api 实例（https://m.sitestar.cn/）
const api = axios.create({
  baseURL: 'https://m.sitestar.cn/',
  timeout: 10000,
})

// // 创建 webapi 实例（https://jswebsite.sitestar.cn/api）
// const webapi = axios.create({
//   baseURL: 'https://jswebsite.sitestar.cn/api',
//   timeout: 10000,
// })

// // 创建 webapi 实例（http://js.sitestar.cn/ajax/）
// const userapi = axios.create({
//   baseURL: 'http://js.sitestar.cn/ajax/',
//   timeout: 10000,
// })

// 创建一个基础实例（可以自定义 baseURL）
const instance = axios.create({
  // baseURL 可以设置为空，也可以根据不同接口设置不同的 baseURL
  timeout: 10000,
});

// 应用拦截器
setInterceptors(api)
// setInterceptors(webapi)
// setInterceptors(userapi)
setInterceptors(instance);

export { api,instance }



// WEBPACK FOOTER //
// ./src/utils/http.js